import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-628efc11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid p-fluid" }
const _hoisted_2 = { class: "col-12 md:col-6" }
const _hoisted_3 = { class: "p-inputgroup" }
const _hoisted_4 = { class: "p-inputgroup-addon" }
const _hoisted_5 = { class: "col-12 md:col-6" }
const _hoisted_6 = { class: "p-inputgroup" }
const _hoisted_7 = { class: "p-inputgroup-addon" }
const _hoisted_8 = { class: "grid p-fluid" }
const _hoisted_9 = { class: "col-12 md:col-10" }
const _hoisted_10 = { class: "p-inputgroup" }
const _hoisted_11 = { class: "p-inputgroup-addon" }
const _hoisted_12 = { class: "grid p-fluid" }
const _hoisted_13 = { class: "col-12 md:col-2" }
const _hoisted_14 = { class: "p-inputgroup" }
const _hoisted_15 = { class: "p-inputgroup-addon" }
const _hoisted_16 = { class: "col-12 md:col-4" }
const _hoisted_17 = { class: "p-inputgroup" }
const _hoisted_18 = { class: "p-inputgroup-addon" }
const _hoisted_19 = { class: "col-12 md:col-6" }
const _hoisted_20 = { class: "p-inputgroup" }
const _hoisted_21 = { class: "p-inputgroup-addon" }
const _hoisted_22 = { class: "grid p-fluid" }
const _hoisted_23 = { class: "col-12 md:col-12" }
const _hoisted_24 = { class: "p-inputgroup" }
const _hoisted_25 = { class: "p-inputgroup-addon" }
const _hoisted_26 = { class: "grid p-fluid" }
const _hoisted_27 = { class: "col-12 md:col-12" }
const _hoisted_28 = { class: "p-inputgroup" }
const _hoisted_29 = { class: "p-inputgroup-addon" }
const _hoisted_30 = { class: "grid p-fluid" }
const _hoisted_31 = { class: "col-12 md:col-5" }
const _hoisted_32 = { class: "p-inputgroup" }
const _hoisted_33 = { class: "p-inputgroup-addon" }
const _hoisted_34 = { class: "col-12 md:col-5" }
const _hoisted_35 = { class: "p-inputgroup" }
const _hoisted_36 = { class: "p-inputgroup-addon" }
const _hoisted_37 = { class: "grid p-fluid" }
const _hoisted_38 = { class: "col-12 md:col-4 mt-3" }
const _hoisted_39 = { class: "p-inputgroup" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "€", -1))
const _hoisted_41 = { class: "p-float-label" }
const _hoisted_42 = { class: "col-12 md:col-4 mt-3" }
const _hoisted_43 = { class: "p-inputgroup" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "€", -1))
const _hoisted_45 = { class: "p-float-label" }
const _hoisted_46 = { class: "col-12 md:col-4 mt-3" }
const _hoisted_47 = { class: "p-inputgroup" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "€", -1))
const _hoisted_49 = { class: "p-float-label" }
const _hoisted_50 = { class: "col-12 md:col-6 mt-2" }
const _hoisted_51 = { class: "p-inputgroup" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "€", -1))
const _hoisted_53 = { class: "p-float-label" }
const _hoisted_54 = { class: "col-12 md:col-6 mt-2" }
const _hoisted_55 = { class: "p-inputgroup" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "€", -1))
const _hoisted_57 = { class: "p-float-label" }
const _hoisted_58 = { class: "grid p-fluid" }
const _hoisted_59 = { class: "col-12 md:col-10" }
const _hoisted_60 = { class: "p-inputgroup" }
const _hoisted_61 = { class: "p-inputgroup-addon" }
const _hoisted_62 = { class: "grid p-fluid" }
const _hoisted_63 = { class: "col-12 md:col-6" }
const _hoisted_64 = { class: "p-inputgroup" }
const _hoisted_65 = { class: "p-inputgroup-addon" }
const _hoisted_66 = { class: "col-12 md:col-6" }
const _hoisted_67 = { class: "p-inputgroup" }
const _hoisted_68 = { class: "p-inputgroup-addon" }
const _hoisted_69 = { class: "grid p-fluid" }
const _hoisted_70 = { class: "col-12 md:col-6" }
const _hoisted_71 = { class: "p-inputgroup" }
const _hoisted_72 = { class: "p-inputgroup-addon" }
const _hoisted_73 = { class: "col-12 md:col-6" }
const _hoisted_74 = { class: "p-inputgroup" }
const _hoisted_75 = { class: "p-inputgroup-addon" }
const _hoisted_76 = { class: "grid p-fluid" }
const _hoisted_77 = { class: "col-12 md:col-6" }
const _hoisted_78 = { class: "p-inputgroup" }
const _hoisted_79 = { class: "p-inputgroup-addon" }
const _hoisted_80 = { class: "col-12 md:col-2" }
const _hoisted_81 = { class: "p-inputgroup" }
const _hoisted_82 = { class: "ml-3" }
const _hoisted_83 = { class: "col-12 md:col-2" }
const _hoisted_84 = { class: "p-inputgroup" }
const _hoisted_85 = { class: "ml-3" }
const _hoisted_86 = { class: "grid" }
const _hoisted_87 = { class: "col-8" }
const _hoisted_88 = { class: "grid" }
const _hoisted_89 = { class: "col-12 p-inputgroup" }
const _hoisted_90 = { class: "p-inputgroup-addon" }
const _hoisted_91 = { class: "col-12 p-inputgroup" }
const _hoisted_92 = { class: "p-inputgroup-addon" }
const _hoisted_93 = { class: "col-6 p-inputgroup" }
const _hoisted_94 = { class: "p-inputgroup-addon" }
const _hoisted_95 = { class: "col-6 p-inputgroup" }
const _hoisted_96 = { class: "p-inputgroup-addon" }
const _hoisted_97 = { class: "col-6 p-inputgroup" }
const _hoisted_98 = { class: "p-inputgroup-addon" }
const _hoisted_99 = { class: "col-6 p-inputgroup" }
const _hoisted_100 = { class: "p-inputgroup-addon" }
const _hoisted_101 = {
  key: 0,
  class: "col-4"
}
const _hoisted_102 = { class: "grid p-fluid" }
const _hoisted_103 = { class: "col-10 md:col-12" }
const _hoisted_104 = { class: "grid p-fluid" }
const _hoisted_105 = { class: "col-12 md:col-4" }
const _hoisted_106 = { class: "p-inputgroup" }
const _hoisted_107 = { class: "p-inputgroup-addon" }
const _hoisted_108 = { class: "col-12 md:col-7" }
const _hoisted_109 = { class: "p-inputgroup" }
const _hoisted_110 = { class: "col-12 md:col-1" }
const _hoisted_111 = { class: "grid p-fluid" }
const _hoisted_112 = { class: "col-10 md:col-1" }
const _hoisted_113 = { class: "p-inputgroup" }
const _hoisted_114 = { class: "p-inputgroup" }
const _hoisted_115 = { class: "p-float-label" }
const _hoisted_116 = { class: "p-inputgroup" }
const _hoisted_117 = { class: "p-float-label" }
const _hoisted_118 = { class: "p-inputgroup" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Price", -1))
const _hoisted_120 = { class: "p-inputgroup" }
const _hoisted_121 = { class: "grid p-fluid" }
const _hoisted_122 = { class: "col-10 md:col-1" }
const _hoisted_123 = { class: "p-inputgroup" }
const _hoisted_124 = { class: "p-inputgroup" }
const _hoisted_125 = { class: "p-inputgroup" }
const _hoisted_126 = { class: "grid p-fluid" }
const _hoisted_127 = { class: "col-10 md:col-1" }
const _hoisted_128 = { class: "grid p-fluid" }
const _hoisted_129 = { class: "col-12 md:col-12" }
const _hoisted_130 = { class: "p-inputgroup" }
const _hoisted_131 = { class: "grid p-fluid" }
const _hoisted_132 = { class: "col-12 md:col-6" }
const _hoisted_133 = { class: "p-inputgroup" }
const _hoisted_134 = { class: "grid p-fluid" }
const _hoisted_135 = { class: "col-12 md:col-6" }
const _hoisted_136 = { class: "p-inputgroup" }
const _hoisted_137 = { class: "grid p-fluid" }
const _hoisted_138 = { class: "col-12 md:col-12" }
const _hoisted_139 = { class: "p-inputgroup" }
const _hoisted_140 = { class: "grid p-fluid" }
const _hoisted_141 = { class: "col-12 md:col-12" }
const _hoisted_142 = { class: "p-inputgroup" }
const _hoisted_143 = { class: "grid p-fluid" }
const _hoisted_144 = { class: "col-12 md:col-6" }
const _hoisted_145 = { class: "p-inputgroup" }
const _hoisted_146 = { class: "grid p-fluid" }
const _hoisted_147 = { class: "col-12 md:col-12" }
const _hoisted_148 = { class: "p-inputgroup" }
const _hoisted_149 = { class: "grid p-fluid" }
const _hoisted_150 = { class: "col-12 md:col-12" }
const _hoisted_151 = { class: "p-inputgroup" }
const _hoisted_152 = { class: "grid p-fluid" }
const _hoisted_153 = { class: "col-12 md:col-6" }
const _hoisted_154 = { class: "p-inputgroup" }
const _hoisted_155 = { class: "p-inputgroup-addon" }
const _hoisted_156 = { class: "grid p-fluid" }
const _hoisted_157 = { class: "col-12 md:col-6" }
const _hoisted_158 = { class: "p-inputgroup" }
const _hoisted_159 = { class: "p-inputgroup-addon" }
const _hoisted_160 = { class: "grid p-fluid" }
const _hoisted_161 = { class: "col-12 md:col-6" }
const _hoisted_162 = { class: "p-inputgroup" }
const _hoisted_163 = { class: "p-inputgroup-addon" }
const _hoisted_164 = { class: "grid p-fluid" }
const _hoisted_165 = { class: "col-12 md:col-6" }
const _hoisted_166 = { class: "p-inputgroup" }
const _hoisted_167 = { class: "p-inputgroup-addon" }
const _hoisted_168 = { class: "grid p-fluid" }
const _hoisted_169 = { class: "col-12 md:col-6" }
const _hoisted_170 = { class: "p-inputgroup" }
const _hoisted_171 = { class: "p-inputgroup-addon" }
const _hoisted_172 = { class: "grid p-fluid" }
const _hoisted_173 = { class: "col-12 md:col-6" }
const _hoisted_174 = { class: "p-inputgroup" }
const _hoisted_175 = { class: "p-inputgroup-addon" }
const _hoisted_176 = { class: "grid p-fluid" }
const _hoisted_177 = { class: "col-12 md:col-6" }
const _hoisted_178 = { class: "p-inputgroup" }
const _hoisted_179 = { class: "p-inputgroup-addon" }
const _hoisted_180 = {
  key: 0,
  class: "card"
}
const _hoisted_181 = { class: "equipment-item" }
const _hoisted_182 = { class: "equipment-item-content" }
const _hoisted_183 = { class: "mb-3" }
const _hoisted_184 = ["src"]
const _hoisted_185 = { class: "mb-1" }
const _hoisted_186 = {
  key: 1,
  class: "grid p-fluid"
}
const _hoisted_187 = { class: "col-12 md:col-12" }
const _hoisted_188 = { class: "flex align-items-center justify-content-end mt-4" }
const _hoisted_189 = { class: "mr-3" }
const _hoisted_190 = {
  key: 2,
  class: "grid p-fluid"
}
const _hoisted_191 = { class: "col-12 md:col-12" }
const _hoisted_192 = { class: "flex align-items-center justify-content-end mt-4" }
const _hoisted_193 = { class: "mr-3" }
const _hoisted_194 = { class: "grid p-fluid" }
const _hoisted_195 = { class: "col-10 md:col-12" }
const _hoisted_196 = {
  class: "fileUploadContainer",
  style: {"word-break":"break-word"}
}
const _hoisted_197 = {
  class: "fileUploadContainer",
  style: {"word-break":"break-word"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_GoogleMapsSmall = _resolveComponent("GoogleMapsSmall")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_Document = _resolveComponent("Document")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Prompt = _resolveComponent("Prompt")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h5", null, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.basicData")), 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.infrastructure")), 1),
          _createVNode(_component_Dropdown, {
            modelValue: $setup.state.equipmentDto.researchInfrastructureId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.equipmentDto.researchInfrastructureId) = $event)),
            options: $setup.researchInfrastructureState.group,
            "option-label": "name",
            "option-value": "id",
            placeholder: $setup.t('content.globalSelectTitle'),
            disabled: $setup.organizationDisabled
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(slotProps.option.number) + " " + _toDisplayString(slotProps.option.name), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "placeholder", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.contactPerson")), 1),
          _createVNode(_component_MultiSelect, {
            modelValue: $setup.state.equipmentDto.userIds,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.equipmentDto.userIds) = $event)),
            options: $setup.state.filteredUsers,
            "option-label": "firstname",
            "option-value": "id",
            placeholder: $setup.t('content.globalSelectTitle')
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(slotProps.option.firstname) + " " + _toDisplayString(slotProps.option.lastname), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.researchGroup")), 1),
          _createVNode(_component_Dropdown, {
            modelValue: $setup.state.equipmentDto.researchGroupId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.equipmentDto.researchGroupId) = $event)),
            options: $setup.getResearchCategories.researchGroup,
            "option-label": "number",
            "option-value": "id",
            placeholder: $setup.t('content.globalSelectTitle')
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(slotProps.option.number) + " " + _toDisplayString(slotProps.option.name), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.number")), 1),
          _createVNode(_component_InputNumber, {
            modelValue: $setup.state.equipmentDto.number,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.equipmentDto.number) = $event)),
            placeholder: 
              $setup.t('content.dataManagement.content.equipment.form.number')
            ,
            "use-grouping": false
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.serialNumber")), 1),
          _createVNode(_component_InputText, {
            modelValue: $setup.state.equipmentDto.serialNumber,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.state.equipmentDto.serialNumber) = $event)),
            placeholder: 
              $setup.t('content.dataManagement.content.equipment.form.serialNumber')
            ,
            "use-grouping": false
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", _hoisted_21, _toDisplayString($setup.t(
              "content.dataManagement.content.equipment.form.serialNumberPurchase"
            )), 1),
          _createVNode(_component_InputText, {
            modelValue: $setup.state.equipmentDto.serialNumberPurchase,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.equipmentDto.serialNumberPurchase) = $event)),
            "use-grouping": false,
            placeholder: 
              $setup.t(
                'content.dataManagement.content.equipment.form.serialNumberPurchase'
              )
            
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("span", _hoisted_25, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.name")), 1),
          _createVNode(_component_InputText, {
            modelValue: $setup.state.equipmentDto.name,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.state.equipmentDto.name) = $event)),
            placeholder: 
              $setup.t('content.dataManagement.content.equipment.form.name')
            
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("span", _hoisted_29, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.englishName")), 1),
          _createVNode(_component_InputText, {
            modelValue: $setup.state.equipmentDto.nameEnglish,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.equipmentDto.nameEnglish) = $event)),
            placeholder: 
              $setup.t('content.dataManagement.content.equipment.form.englishName')
            
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("span", _hoisted_33, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.webURL")), 1),
          _createVNode(_component_InputText, {
            modelValue: $setup.state.equipmentDto.webURL,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.state.equipmentDto.webURL) = $event)),
            placeholder: 
              $setup.t('content.dataManagement.content.equipment.form.webURL')
            
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("span", _hoisted_36, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.year")), 1),
          _createVNode(_component_InputText, {
            modelValue: $setup.state.equipmentDto.purchaseEquipmentDateYear,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.state.equipmentDto.purchaseEquipmentDateYear) = $event)),
            placeholder: 
              $setup.t('content.dataManagement.content.equipment.form.year')
            
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_component_InputNumber, {
              modelValue: $setup.state.equipmentDto.purchasePrice,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.state.equipmentDto.purchasePrice) = $event)),
              mode: "currency",
              currency: "EUR"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.purchasePrice")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_InputNumber, {
              modelValue: $setup.state.equipmentDto.amortizationCost,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.state.equipmentDto.amortizationCost) = $event)),
              mode: "currency",
              currency: "EUR"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, _toDisplayString($setup.t(
                "content.dataManagement.content.equipment.form.amortizationCost"
              )), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _hoisted_48,
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_component_InputNumber, {
              modelValue: $setup.state.equipmentDto.materialsAndServicesCost,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.state.equipmentDto.materialsAndServicesCost) = $event)),
              mode: "currency",
              currency: "EUR"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, _toDisplayString($setup.t(
                "content.dataManagement.content.equipment.form.materialsAndServicesCost"
              )), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_component_InputNumber, {
              modelValue: $setup.state.equipmentDto.workCost,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.state.equipmentDto.workCost) = $event)),
              mode: "currency",
              currency: "EUR"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.workCost")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _createElementVNode("div", _hoisted_57, [
            _createVNode(_component_InputNumber, {
              modelValue: $setup.state.equipmentDto.sumMaintenanceCost,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.state.equipmentDto.sumMaintenanceCost) = $event)),
              mode: "currency",
              currency: "EUR"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, _toDisplayString($setup.t(
                "content.dataManagement.content.equipment.form.sumMaintenanceCost"
              )), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_58, [
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("span", _hoisted_61, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.fundingType")), 1),
          _createVNode(_component_MultiSelect, {
            modelValue: $setup.state.equipmentDto.fundingTypeIds,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.state.equipmentDto.fundingTypeIds) = $event)),
            options: $setup.getResearchCategories.equipmentFundingTypes,
            "option-label": $setup.state.localProperty,
            "option-value": "id",
            placeholder: $setup.t('content.globalSelectTitle')
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(slotProps.option.number) + " " + _toDisplayString(slotProps.option[$setup.state.localProperty]) + " (" + _toDisplayString(slotProps.option.type) + ") ", 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "option-label", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("span", _hoisted_65, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.costUnit")), 1),
          _createVNode(_component_InputText, {
            modelValue: $setup.state.equipmentDto.costObject,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.state.equipmentDto.costObject) = $event)),
            placeholder: 
              $setup.t('content.dataManagement.content.equipment.form.costUnit')
            
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ]),
      _createElementVNode("div", _hoisted_66, [
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("span", _hoisted_68, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.costObject")), 1),
          _createVNode(_component_InputText, {
            modelValue: $setup.state.equipmentDto.costUnit,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.state.equipmentDto.costUnit) = $event)),
            placeholder: 
              $setup.t('content.dataManagement.content.equipment.form.costObject')
            
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_69, [
      _createElementVNode("div", _hoisted_70, [
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("span", _hoisted_72, _toDisplayString($setup.t(
              "content.dataManagement.content.equipment.form.protectionAgainstIonizingRadiation"
            )), 1),
          _createVNode(_component_InputText, {
            modelValue: $setup.state.equipmentDto.protectionAgainstIonizingRadiation,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.state.equipmentDto.protectionAgainstIonizingRadiation) = $event)),
            placeholder: 
              $setup.t(
                'content.dataManagement.content.equipment.form.protectionAgainstIonizingRadiation'
              )
            
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ]),
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("span", _hoisted_75, _toDisplayString($setup.t(
              "content.dataManagement.content.equipment.form.measuresAgainstIonizingRadiation"
            )), 1),
          _createVNode(_component_InputText, {
            modelValue: $setup.state.equipmentDto.measuresAgainstIonizingRadiation,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.state.equipmentDto.measuresAgainstIonizingRadiation) = $event)),
            placeholder: 
              $setup.t(
                'content.dataManagement.content.equipment.form.measuresAgainstIonizingRadiation'
              )
            
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_76, [
      _createElementVNode("div", _hoisted_77, [
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("span", _hoisted_79, _toDisplayString($setup.t(
              "content.dataManagement.content.equipment.form.amortizationPeriod"
            )), 1),
          _createVNode(_component_InputText, {
            modelValue: $setup.state.equipmentDto.amortizationPeriod,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.state.equipmentDto.amortizationPeriod) = $event)),
            placeholder: 
              $setup.t(
                'content.dataManagement.content.equipment.form.amortizationPeriod'
              )
            
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ]),
      _createElementVNode("div", _hoisted_80, [
        _createElementVNode("div", _hoisted_81, [
          _createVNode(_component_InputSwitch, {
            modelValue: $setup.state.equipmentDto.publicAnnouncement,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.state.equipmentDto.publicAnnouncement) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("span", _hoisted_82, _toDisplayString($setup.t(
              "content.dataManagement.content.equipment.form.publicAnnouncement"
            )), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_83, [
        _createElementVNode("div", _hoisted_84, [
          _createVNode(_component_InputSwitch, {
            modelValue: $setup.state.equipmentDto.internalUseOnly,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.state.equipmentDto.internalUseOnly) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("span", _hoisted_85, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.internalUseOnly")), 1)
        ])
      ])
    ]),
    _createElementVNode("h5", null, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.locationData")), 1),
    _createElementVNode("div", _hoisted_86, [
      _createElementVNode("div", _hoisted_87, [
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("span", _hoisted_90, _toDisplayString($setup.t("content.dataManagement.content.form.city")), 1),
            _createVNode(_component_Dropdown, {
              modelValue: $setup.state.equipmentDto.cityId,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.state.equipmentDto.cityId) = $event)),
              options: $setup.getResearchCategories.cities,
              "option-label": "cityName",
              "option-value": "id",
              placeholder: $setup.t('content.dataManagement.content.form.city')
            }, null, 8, ["modelValue", "options", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_91, [
            _createElementVNode("span", _hoisted_92, _toDisplayString($setup.t("content.dataManagement.content.form.address")), 1),
            _createVNode(_component_AutoComplete, {
              modelValue: $setup.state.equipmentDto.street,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.state.equipmentDto.street) = $event)),
              placeholder: $setup.t('content.dataManagement.content.form.address')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("span", _hoisted_94, _toDisplayString($setup.t("content.dataManagement.content.form.postalCode")), 1),
            _createVNode(_component_AutoComplete, {
              modelValue: $setup.state.equipmentDto.postalCode,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.state.equipmentDto.postalCode) = $event)),
              placeholder: $setup.t('content.dataManagement.content.form.postalCode')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("span", _hoisted_96, _toDisplayString($setup.t("content.dataManagement.content.form.department")), 1),
            _createVNode(_component_InputText, {
              modelValue: $setup.state.equipmentDto.department,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.state.equipmentDto.department) = $event)),
              placeholder: $setup.t('content.dataManagement.content.form.department')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("span", _hoisted_98, _toDisplayString($setup.t("content.dataManagement.content.form.latitude")), 1),
            _createVNode(_component_InputNumber, {
              modelValue: $setup.state.equipmentDto.latitude,
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.state.equipmentDto.latitude) = $event)),
              placeholder: $setup.t('content.dataManagement.content.form.latitude'),
              mode: "decimal",
              "min-fraction-digits": 6
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("span", _hoisted_100, _toDisplayString($setup.t("content.dataManagement.content.form.longitude")), 1),
            _createVNode(_component_InputNumber, {
              modelValue: $setup.state.equipmentDto.longitude,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.state.equipmentDto.longitude) = $event)),
              placeholder: $setup.t('content.dataManagement.content.form.longitude'),
              mode: "decimal",
              "min-fraction-digits": 6
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ])
      ]),
      ($setup.locationData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
            _createVNode(_component_GoogleMapsSmall, { location: $setup.locationData }, null, 8, ["location"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_102, [
      _createElementVNode("div", _hoisted_103, [
        _createVNode(_component_Button, {
          label: $setup.t('content.globalSaveButton'),
          class: "minWidth",
          onClick: $setup.onResearchEquipmentCreateClick
        }, null, 8, ["label", "onClick"])
      ])
    ]),
    _createElementVNode("h5", null, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.componentData")), 1),
    _createElementVNode("div", _hoisted_104, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.equipmentDto.components, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _createElementVNode("div", _hoisted_105, [
            _createElementVNode("div", _hoisted_106, [
              _createElementVNode("span", _hoisted_107, _toDisplayString($setup.t(
                "content.dataManagement.content.equipment.form.equipmentComponentName"
              )), 1),
              _createVNode(_component_InputText, {
                modelValue: item.name,
                "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                placeholder: 
                $setup.t(
                  'content.dataManagement.content.equipment.form.equipmentComponentName'
                )
              
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_108, [
            _createElementVNode("div", _hoisted_109, [
              _createVNode(_component_InputText, {
                modelValue: item.description,
                "onUpdate:modelValue": ($event: any) => ((item.description) = $event),
                placeholder: 
                $setup.t(
                  'content.dataManagement.content.equipment.form.equipmentComponentDescription'
                )
              
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_110, [
            _createVNode(_component_Button, {
              icon: "pi pi-times",
              class: "p-button-outlined",
              onClick: ($event: any) => ($setup.onEquipmentComponentRemoveClick(index))
            }, null, 8, ["onClick"])
          ])
        ], 64))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_111, [
      _createElementVNode("div", _hoisted_112, [
        _createVNode(_component_Button, {
          icon: "pi pi-plus",
          class: "p-button-outlined",
          onClick: $setup.onEquipmentComponentAddClick
        }, null, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("h5", null, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.priceListData")), 1),
    _createVNode(_component_DataTable, {
      value: $setup.state.equipmentDto.pricelist
    }, {
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString($setup.t("content.noData")), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "userExpertiseLevel",
          header: 
          $setup.t(
            'content.researchEquipment.content.priceListUserExpertiseLevelHeaderTitle'
          )
        
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_113, [
              _createVNode(_component_Dropdown, {
                modelValue: data.userExpertiseLevel,
                "onUpdate:modelValue": ($event: any) => ((data.userExpertiseLevel) = $event),
                disabled: data.id != undefined && data.id != null,
                options: [
                {
                  key: 'EXPERIENCED_USER',
                  value: $setup.t(
                    'content.researchEquipment.content.priceListExperiencedUser'
                  ),
                },
                {
                  key: 'INEXPERIENCED_USER',
                  value: $setup.t(
                    'content.researchEquipment.content.priceListInexperiencedUser'
                  ),
                },
              ],
                placeholder: $setup.t('content.globalSelectTitle'),
                "option-label": "value",
                "option-value": "key"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "options", "placeholder"])
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "dateFrom",
          header: 
          $setup.t('content.researchEquipment.content.priceListFromHeaderTitle')
        
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_114, [
              _createElementVNode("div", _hoisted_115, [
                _createVNode(_component_Calendar, {
                  modelValue: data.dateFrom,
                  "onUpdate:modelValue": ($event: any) => ((data.dateFrom) = $event),
                  "show-icon": true,
                  disabled: data.id != undefined && data.id != null,
                  "date-format": _ctx.dateFormat,
                  "hide-on-date-time-select": true
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "date-format"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "dateTo",
          header: $setup.t('content.researchEquipment.content.priceListToHeaderTitle')
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_116, [
              _createElementVNode("div", _hoisted_117, [
                _createVNode(_component_Calendar, {
                  modelValue: data.dateTo,
                  "onUpdate:modelValue": ($event: any) => ((data.dateTo) = $event),
                  "show-icon": true,
                  disabled: data.id != undefined && data.id != null,
                  "date-format": _ctx.dateFormat,
                  "hide-on-date-time-select": true
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "date-format"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "price",
          header: 
          $setup.t('content.researchEquipment.content.priceListPriceHeaderTitle')
        
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_118, [
              _hoisted_119,
              _createVNode(_component_InputNumber, {
                modelValue: data.price,
                "onUpdate:modelValue": ($event: any) => ((data.price) = $event),
                disabled: data.id != undefined && data.id != null,
                mode: "currency",
                currency: "EUR",
                placeholder: 
                $setup.t(
                  'content.dataManagement.content.equipment.form.equipmentPrice'
                )
              
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder"])
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "description",
          header: 
          $setup.t('content.researchEquipment.content.priceListDescriptionHeaderTitle')
        
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_120, [
              _createVNode(_component_InputText, {
                modelValue: data.description,
                "onUpdate:modelValue": ($event: any) => ((data.description) = $event),
                placeholder: 
                $setup.t(
                  'content.dataManagement.content.equipment.form.equipmentDescription'
                )
              ,
                "use-grouping": false
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, { field: "id" }, {
          body: _withCtx(({ data }) => [
            (!data.id)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  icon: "pi pi-times",
                  class: "p-button-outlined",
                  onClick: ($event: any) => (
              $setup.onEquipmentPriceItemRemoveClick(
                $setup.state.equipmentDto.pricelist.indexOf(data)
              )
            )
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"]),
    _createElementVNode("div", _hoisted_121, [
      _createElementVNode("div", _hoisted_122, [
        _createVNode(_component_Button, {
          label: $setup.t('content.globalAddNewItem'),
          class: "minWidth mt-3",
          onClick: $setup.onEquipmentPriceItemAddClick
        }, null, 8, ["label", "onClick"])
      ])
    ]),
    _createElementVNode("h5", null, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.utilizationListData")), 1),
    _createVNode(_component_DataTable, {
      value: $setup.state.equipmentDto.utilizationlist
    }, {
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString($setup.t("content.noData")), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "year",
          header: $setup.t('content.researchEquipment.content.utilizationListYear')
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_123, [
              _createVNode(_component_InputNumber, {
                modelValue: data.year,
                "onUpdate:modelValue": ($event: any) => ((data.year) = $event),
                disabled: data.id != undefined && data.id != null,
                "use-grouping": false,
                placeholder: 
                $setup.t('content.researchEquipment.content.utilizationListYear')
              
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder"])
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "annualUtilizationRatePercent",
          header: 
          $setup.t(
            'content.researchEquipment.content.utilizationListAnnualUtilizationRatePercent'
          )
        
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_124, [
              _createVNode(_component_InputNumber, {
                modelValue: data.annualUtilizationRatePercent,
                "onUpdate:modelValue": ($event: any) => ((data.annualUtilizationRatePercent) = $event),
                "use-grouping": false,
                mode: "decimal",
                "min-fraction-digits": 2,
                disabled: data.id != undefined && data.id != null,
                placeholder: 
                $setup.t(
                  'content.researchEquipment.content.utilizationListAnnualUtilizationRatePercent'
                )
              
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder"])
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "depreciationRatePercentage",
          header: 
          $setup.t(
            'content.researchEquipment.content.utilizationListDepreciationRatePercentage'
          )
        
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_125, [
              _createVNode(_component_InputNumber, {
                modelValue: data.depreciationRatePercentage,
                "onUpdate:modelValue": ($event: any) => ((data.depreciationRatePercentage) = $event),
                mode: "decimal",
                "min-fraction-digits": 2,
                disabled: data.id != undefined && data.id != null,
                "use-grouping": false,
                placeholder: 
                $setup.t(
                  'content.researchEquipment.content.utilizationListDepreciationRatePercentage'
                )
              
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder"])
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, { field: "id" }, {
          body: _withCtx(({ data }) => [
            (!data.id)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  icon: "pi pi-times",
                  class: "p-button-outlined",
                  onClick: ($event: any) => (
              $setup.onEquipmentUtilizationItemRemoveClick(
                $setup.state.equipmentDto.pricelist.indexOf(data)
              )
            )
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"]),
    _createElementVNode("div", _hoisted_126, [
      _createElementVNode("div", _hoisted_127, [
        _createVNode(_component_Button, {
          label: $setup.t('content.globalAddNewItem'),
          class: "minWidth mt-3",
          onClick: $setup.onEquipmentUtilizationItemAddClick
        }, null, 8, ["label", "onClick"])
      ])
    ]),
    _createElementVNode("h5", null, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.technicalDescription")), 1),
    _createElementVNode("div", _hoisted_128, [
      _createElementVNode("div", _hoisted_129, [
        _createElementVNode("div", _hoisted_130, [
          _createVNode(_component_Textarea, {
            modelValue: $setup.state.equipmentDto.technicalCharacteristic,
            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.state.equipmentDto.technicalCharacteristic) = $event)),
            placeholder: 
              $setup.t(
                'content.dataManagement.content.equipment.form.techicalCharacteristic'
              )
            ,
            "auto-resize": true,
            rows: "3"
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("h5", null, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.equipmentAccessMethod")), 1),
    _createElementVNode("div", _hoisted_131, [
      _createElementVNode("div", _hoisted_132, [
        _createElementVNode("div", _hoisted_133, [
          _createVNode(_component_Dropdown, {
            modelValue: $setup.state.equipmentDto.equipmentAccessMethodId,
            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.state.equipmentDto.equipmentAccessMethodId) = $event)),
            options: $setup.getResearchCategories.accessMethods,
            "option-label": $setup.state.localProperty,
            "option-value": "id",
            placeholder: $setup.t('content.globalSelectTitle')
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(slotProps.option.number) + " " + _toDisplayString(slotProps.option[$setup.state.localProperty]), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "option-label", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("h5", null, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.equipmentPurpose")), 1),
    _createElementVNode("div", _hoisted_134, [
      _createElementVNode("div", _hoisted_135, [
        _createElementVNode("div", _hoisted_136, [
          _createVNode(_component_Dropdown, {
            modelValue: $setup.state.equipmentDto.equipmentAccessPurposeId,
            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (($setup.state.equipmentDto.equipmentAccessPurposeId) = $event)),
            options: $setup.getResearchCategories.accessPurposes,
            "option-label": $setup.state.localProperty,
            "option-value": "id",
            placeholder: $setup.t('content.globalSelectTitle')
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(slotProps.option.number) + " " + _toDisplayString(slotProps.option[$setup.state.localProperty]), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "option-label", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("h5", null, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.purposeDescription")), 1),
    _createElementVNode("div", _hoisted_137, [
      _createElementVNode("div", _hoisted_138, [
        _createElementVNode("div", _hoisted_139, [
          _createVNode(_component_Textarea, {
            modelValue: $setup.state.equipmentDto.purposeTypeDescription,
            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (($setup.state.equipmentDto.purposeTypeDescription) = $event)),
            placeholder: 
              $setup.t(
                'content.dataManagement.content.equipment.form.purposeDescription'
              )
            ,
            "auto-resize": true,
            rows: "3"
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("h5", null, _toDisplayString($setup.t(
          "content.dataManagement.content.equipment.form.purposeDescriptionEnglish"
        )), 1),
    _createElementVNode("div", _hoisted_140, [
      _createElementVNode("div", _hoisted_141, [
        _createElementVNode("div", _hoisted_142, [
          _createVNode(_component_Textarea, {
            modelValue: $setup.state.equipmentDto.purposeTypeDescriptionEnglish,
            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (($setup.state.equipmentDto.purposeTypeDescriptionEnglish) = $event)),
            placeholder: 
              $setup.t(
                'content.dataManagement.content.equipment.form.purposeDescriptionEnglish'
              )
            ,
            "auto-resize": true,
            rows: "3"
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("h5", null, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.equipmentAccessType")), 1),
    _createElementVNode("div", _hoisted_143, [
      _createElementVNode("div", _hoisted_144, [
        _createElementVNode("div", _hoisted_145, [
          _createVNode(_component_Dropdown, {
            modelValue: $setup.state.equipmentDto.equipmentAccessTypeId,
            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (($setup.state.equipmentDto.equipmentAccessTypeId) = $event)),
            options: $setup.getResearchCategories.accessTypes,
            "option-label": $setup.state.localProperty,
            "option-value": "id",
            placeholder: $setup.t('content.globalSelectTitle')
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(slotProps.option.number) + " " + _toDisplayString(slotProps.option[$setup.state.localProperty]), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "option-label", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("h5", null, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.accessTypeDescription")), 1),
    _createElementVNode("div", _hoisted_146, [
      _createElementVNode("div", _hoisted_147, [
        _createElementVNode("div", _hoisted_148, [
          _createVNode(_component_Textarea, {
            modelValue: $setup.state.equipmentDto.accessTypeDescription,
            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (($setup.state.equipmentDto.accessTypeDescription) = $event)),
            placeholder: 
              $setup.t(
                'content.dataManagement.content.equipment.form.accessTypeDescription'
              )
            ,
            "auto-resize": true,
            rows: "3"
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("h5", null, _toDisplayString($setup.t(
          "content.dataManagement.content.equipment.form.accessTypeDescriptionEnglish"
        )), 1),
    _createElementVNode("div", _hoisted_149, [
      _createElementVNode("div", _hoisted_150, [
        _createElementVNode("div", _hoisted_151, [
          _createVNode(_component_Textarea, {
            modelValue: $setup.state.equipmentDto.accessTypeDescriptionEnglish,
            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (($setup.state.equipmentDto.accessTypeDescriptionEnglish) = $event)),
            placeholder: 
              $setup.t(
                'content.dataManagement.content.equipment.form.accessTypeDescriptionEnglish'
              )
            ,
            "auto-resize": true,
            rows: "3"
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("h5", null, _toDisplayString($setup.t(
          "content.dataManagement.content.equipment.form.equipmentClassification"
        )), 1),
    _createElementVNode("div", _hoisted_152, [
      _createElementVNode("div", _hoisted_153, [
        _createElementVNode("div", _hoisted_154, [
          _createElementVNode("span", _hoisted_155, _toDisplayString($setup.t(
              "content.dataManagement.content.equipment.form.equipmentResearchOrientationType"
            )), 1),
          _createVNode(_component_MultiSelect, {
            modelValue: $setup.state.equipmentDto.equipmentResearchOrientationTypeIds,
            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (($setup.state.equipmentDto.equipmentResearchOrientationTypeIds) = $event)),
            options: $setup.getResearchCategories.equipmentResearchOrientationTypes,
            "option-label": $setup.state.localProperty,
            "option-value": "id",
            placeholder: $setup.t('content.globalSelectTitle')
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(slotProps.option.number) + " " + _toDisplayString(slotProps.option[$setup.state.localProperty]), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "option-label", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_156, [
      _createElementVNode("div", _hoisted_157, [
        _createElementVNode("div", _hoisted_158, [
          _createElementVNode("span", _hoisted_159, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.uniLeedClass")), 1),
          _createVNode(_component_Dropdown, {
            modelValue: $setup.state.equipmentDto.equipmentUniLeedClassTypeId,
            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (($setup.state.equipmentDto.equipmentUniLeedClassTypeId) = $event)),
            options: $setup.getResearchCategories.uniLeedClassTypes,
            "option-label": $setup.state.localProperty,
            "option-value": "id",
            placeholder: $setup.t('content.globalSelectTitle')
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(slotProps.option.number) + " " + _toDisplayString(slotProps.option[$setup.state.localProperty]), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "option-label", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_160, [
      _createElementVNode("div", _hoisted_161, [
        _createElementVNode("div", _hoisted_162, [
          _createElementVNode("span", _hoisted_163, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.uniLeedOrder")), 1),
          _createVNode(_component_Dropdown, {
            modelValue: $setup.state.equipmentDto.equipmentUniLeedOrderTypeId,
            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (($setup.state.equipmentDto.equipmentUniLeedOrderTypeId) = $event)),
            options: $setup.state.filteredUniLeedOrderType,
            "option-label": $setup.state.localProperty,
            "option-value": "id",
            placeholder: $setup.t('content.globalSelectTitle')
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(slotProps.option.number) + " " + _toDisplayString(slotProps.option[$setup.state.localProperty]), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "option-label", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_164, [
      _createElementVNode("div", _hoisted_165, [
        _createElementVNode("div", _hoisted_166, [
          _createElementVNode("span", _hoisted_167, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.uniLeedType")), 1),
          _createVNode(_component_Dropdown, {
            modelValue: $setup.state.equipmentDto.equipmentUniLeedTypeId,
            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (($setup.state.equipmentDto.equipmentUniLeedTypeId) = $event)),
            options: $setup.state.filteredUniLeedType,
            "option-label": $setup.state.localProperty,
            "option-value": "id",
            placeholder: $setup.t('content.globalSelectTitle')
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(slotProps.option.number) + " " + _toDisplayString(slotProps.option[$setup.state.localProperty]), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "option-label", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_168, [
      _createElementVNode("div", _hoisted_169, [
        _createElementVNode("div", _hoisted_170, [
          _createElementVNode("span", _hoisted_171, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.equipmentCriteria")), 1),
          _createVNode(_component_Dropdown, {
            modelValue: $setup.state.equipmentDto.equipmentCriteriaId,
            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (($setup.state.equipmentDto.equipmentCriteriaId) = $event)),
            options: $setup.getResearchCategories.equipmentCriterion,
            "option-label": $setup.state.localProperty,
            "option-value": "id",
            placeholder: $setup.t('content.globalSelectTitle')
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(slotProps.option.number) + " " + _toDisplayString(slotProps.option[$setup.state.localProperty]), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "option-label", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_172, [
      _createElementVNode("div", _hoisted_173, [
        _createElementVNode("div", _hoisted_174, [
          _createElementVNode("span", _hoisted_175, _toDisplayString($setup.t(
              "content.dataManagement.content.equipment.form.equipmentLifeCycle"
            )), 1),
          _createVNode(_component_Dropdown, {
            modelValue: $setup.state.equipmentDto.equipmentLifeCycleStatusId,
            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (($setup.state.equipmentDto.equipmentLifeCycleStatusId) = $event)),
            options: $setup.getResearchCategories.lifeStatusCodes,
            "option-label": $setup.state.localProperty,
            "option-value": "id",
            placeholder: $setup.t('content.globalSelectTitle')
          }, null, 8, ["modelValue", "options", "option-label", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_176, [
      _createElementVNode("div", _hoisted_177, [
        _createElementVNode("div", _hoisted_178, [
          _createElementVNode("span", _hoisted_179, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.targetGroup")), 1),
          _createVNode(_component_MultiSelect, {
            modelValue: $setup.state.equipmentDto.targetGroupIds,
            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (($setup.state.equipmentDto.targetGroupIds) = $event)),
            options: $setup.getResearchCategories.targetGroup,
            "option-label": $setup.state.localProperty,
            "option-value": "id",
            placeholder: $setup.t('content.globalSelectTitle')
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(slotProps.option.number) + " " + _toDisplayString(slotProps.option[$setup.state.localProperty]), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options", "option-label", "placeholder"])
        ])
      ])
    ]),
    ($setup.state.equipmentDto.researchEquipmentId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
          _createVNode(_component_Carousel, {
            value: $setup.state.equipmentImages,
            "num-visible": 6,
            "num-scroll": 3,
            "responsive-options": $setup.state.responsiveOptions
          }, {
            header: _withCtx(() => [
              _createElementVNode("h5", null, _toDisplayString($setup.t(
                "content.dataManagement.content.equipment.form.uploadedImagesData"
              )), 1)
            ]),
            item: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_181, [
                _createElementVNode("div", _hoisted_182, [
                  _createElementVNode("div", _hoisted_183, [
                    _createElementVNode("img", {
                      src: slotProps.data.url,
                      alt: "Upload image",
                      class: "equipment-image"
                    }, null, 8, _hoisted_184)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", _hoisted_185, _toDisplayString($setup.getFileName(slotProps.data.name)), 1)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["value", "responsive-options"])
        ]))
      : _createCommentVNode("", true),
    ($setup.state.equipmentDto.researchEquipmentId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
          _createElementVNode("div", _hoisted_187, [
            ($setup.state.equipmentDto.images)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.equipmentDto.images, (item, index) => {
                  return (_openBlock(), _createBlock(_component_Document, {
                    key: index,
                    label: item.name,
                    href: item.name
                  }, {
                    button: _withCtx(() => [
                      _createVNode(_component_Button, {
                        icon: "pi pi-times",
                        class: "p-button-outlined p-button-danger",
                        onClick: ($event: any) => ($setup.onRemoveEquipmentImageClickDialog(index, item))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["label", "href"]))
                }), 128))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_188, [
              _createElementVNode("strong", _hoisted_189, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.addNewImage")), 1),
              _createVNode(_component_Button, {
                icon: "pi pi-plus",
                class: "p-button-outlined",
                onClick: _cache[44] || (_cache[44] = ($event: any) => ($setup.state.documentUploadDialog = true))
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.state.equipmentDto.researchEquipmentId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
          _createElementVNode("h5", null, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.uploadedFilesData")), 1),
          _createElementVNode("div", _hoisted_191, [
            ($setup.state.equipmentDto.files)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.equipmentDto.files, (item, index) => {
                  return (_openBlock(), _createBlock(_component_Document, {
                    key: index,
                    label: item.name,
                    href: item.url
                  }, {
                    button: _withCtx(() => [
                      _createVNode(_component_Button, {
                        icon: "pi pi-times",
                        class: "p-button-outlined p-button-danger",
                        onClick: ($event: any) => ($setup.onRemoveEquipmentFileClickDialog(index, item))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["label", "href"]))
                }), 128))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_192, [
              _createElementVNode("strong", _hoisted_193, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.addNewFile")), 1),
              _createVNode(_component_Button, {
                icon: "pi pi-plus",
                class: "p-button-outlined",
                onClick: _cache[45] || (_cache[45] = ($event: any) => ($setup.state.documentUploadDialogFile = true))
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_194, [
      _createElementVNode("div", _hoisted_195, [
        _createVNode(_component_Button, {
          label: $setup.t('content.globalSaveButton'),
          class: "minWidth",
          onClick: $setup.onResearchEquipmentCreateClick
        }, null, 8, ["label", "onClick"])
      ])
    ]),
    _createVNode(_component_Prompt, {
      visible: $setup.state.documentUploadDialog,
      title: $setup.t('content.globalUploadButton'),
      onClose: _cache[47] || (_cache[47] = ($event: any) => ($setup.state.documentUploadDialog = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_196, [
          _createVNode(_component_FileUpload, {
            name: "demo[]",
            "cancel-label": $setup.t('content.globalCancelButton'),
            "upload-label": $setup.t('content.globalUploadButton'),
            "choose-label": $setup.t('content.globalSelectTitle'),
            "custom-upload": true,
            onUploader: $setup.onPreviewEquipmentImageUploadClick
          }, {
            empty: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString($setup.t("content.globalDragAndDropText")), 1)
            ]),
            _: 1
          }, 8, ["cancel-label", "upload-label", "choose-label", "onUploader"])
        ])
      ]),
      actions: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "p-button-outlined",
          label: $setup.t('content.globalCancelButton'),
          onClick: _cache[46] || (_cache[46] = ($event: any) => ($setup.state.documentUploadDialog = false))
        }, null, 8, ["label"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_component_Prompt, {
      visible: $setup.state.documentUploadDialogFile,
      title: $setup.t('content.globalUploadButton'),
      onClose: _cache[49] || (_cache[49] = ($event: any) => ($setup.state.documentUploadDialogFile = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_197, [
          _createVNode(_component_FileUpload, {
            name: "demo[]",
            "custom-upload": true,
            "cancel-label": $setup.t('content.globalCancelButton'),
            "upload-label": $setup.t('content.globalUploadButton'),
            "choose-label": $setup.t('content.globalSelectTitle'),
            onUploader: $setup.onPreviewEquipmentFileUploadClick
          }, {
            empty: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString($setup.t("content.globalDragAndDropText")), 1)
            ]),
            _: 1
          }, 8, ["cancel-label", "upload-label", "choose-label", "onUploader"])
        ])
      ]),
      actions: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "p-button-outlined",
          label: $setup.t('content.globalCancelButton'),
          onClick: _cache[48] || (_cache[48] = ($event: any) => ($setup.state.documentUploadDialogFile = false))
        }, null, 8, ["label"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_component_Prompt, {
      visible: $setup.state.confirmationDialog,
      type: "alert",
      title: $setup.t('content.globalDeleteButton'),
      onClose: _cache[52] || (_cache[52] = ($event: any) => ($setup.state.confirmationDialog = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("h3", null, _toDisplayString($setup.t("content.globalAreYouSure")), 1)
      ]),
      actions: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "p-button-outlined",
          label: $setup.t('content.globalCancelButton'),
          onClick: _cache[50] || (_cache[50] = ($event: any) => ($setup.state.confirmationDialog = false))
        }, null, 8, ["label"]),
        _createVNode(_component_Button, {
          label: $setup.t('content.globalDeleteButton'),
          onClick: _cache[51] || (_cache[51] = ($event: any) => ($setup.onRemoveEquipmentImageClick()))
        }, null, 8, ["label"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_component_Prompt, {
      visible: $setup.state.confirmationDialogFile,
      type: "alert",
      title: $setup.t('content.globalDeleteButton'),
      onClose: _cache[55] || (_cache[55] = ($event: any) => ($setup.state.confirmationDialogFile = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("h3", null, _toDisplayString($setup.t("content.globalAreYouSure")), 1)
      ]),
      actions: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "p-button-outlined",
          label: $setup.t('content.globalCancelButton'),
          onClick: _cache[53] || (_cache[53] = ($event: any) => ($setup.state.confirmationDialogFile = false))
        }, null, 8, ["label"]),
        _createVNode(_component_Button, {
          label: $setup.t('content.globalDeleteButton'),
          onClick: _cache[54] || (_cache[54] = ($event: any) => ($setup.onRemoveEquipmentFileClick()))
        }, null, 8, ["label"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}